import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { KeycloakInitError } from './app/keycloak-provider';

bootstrapApplication(App, appConfig).catch((err) => {
  console.error(err);
  // A Keycloak init/auth failure (e.g. the auth server is down) must not leave the
  // CMS running unauthenticated — show a generic Dutch maintenance page instead.
  if (err instanceof KeycloakInitError) {
    showMaintenancePage();
  }
});

function showMaintenancePage(): void {
  document.body.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;
                font-family:Roboto,sans-serif;text-align:center;padding:2rem;color:#653E00;">
      <div style="max-width:32rem;">
        <h1 style="font-weight:500;">Tijdelijk niet beschikbaar</h1>
        <p>We ondervinden momenteel technische problemen en werken aan een oplossing.
           Probeer het over enkele minuten opnieuw.</p>
      </div>
    </div>`;
}
